import { statusOptions } from '@/common/options';
import {
  PrimaryButton,
  PrimaryOutlineButton,
} from '@/components/button/button-component';
import Input from '@/components/react-hook-form-inputs/input/input-component';
import SelectSearch from '@/components/react-hook-form-inputs/select-search/select-search-component';
import UploadImageThumbnail from '@/components/upload-image-thumbnail/upload-image-thumbnail';
import {
  requiredValidationDropdownMessage,
  requiredValidationMessage,
} from '@/utils/validations';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { BsX } from 'react-icons/bs';
import Styled from './product-category-add-edit-form-style';

/**
 * Page that shows the form to add or edit a Category.
 * @param {object} props The props object.
 * @param {Function} props.setModalAction The function to set the modal action.
 * @param {object} props.modalAction The modal action object.
 * @param {boolean} props.loading The loading state.
 * @returns {JSX.Element} The Category Add Edit Form component.
 */
const ProductCategoryAddEditForm = ({
  setModalAction,
  modalAction,
  loading,
}) => {
  const [categoryStatus, setCategoryStatus] = useState('');

  const {
    formState: { isLoading: formLoading },
    watch,
  } = useFormContext();

  const closeCreateEditModal = () => {
    setModalAction({ label: '', id: null });
  };

  const categoryStatusInitialColor = watch('status');
  const isLoading = formLoading || loading;

  const changeCategoryStatus = (e) => {
    setCategoryStatus(e.target.value);
  };

  const circleIcon = (
    <Styled.StatusCircle
      status={categoryStatusInitialColor || categoryStatus}
    />
  );

  return (
    <>
      <Styled.FormContainer>
        <Input
          disabled={isLoading}
          label="Category Name"
          placeholder="Category Name"
          name="name"
          registerOptions={{
            required: requiredValidationMessage,
          }}
        />
        <Input
          disabled={isLoading}
          label="Category Description"
          placeholder="Description"
          name="description"
          registerOptions={{
            required: requiredValidationMessage,
          }}
        />
        <Input
          disabled={isLoading}
          label="Category Slug"
          placeholder="slug"
          name="slug"
          registerOptions={{
            required: requiredValidationMessage,
          }}
        />
        <UploadImageThumbnail name="image_thumbnail" loading={isLoading} />
        <SelectSearch
          cy="selCompanyStatus"
          header="Status"
          name="status"
          label="Please select a status"
          options={statusOptions}
          isLoading={isLoading}
          isDisabled={isLoading}
          icon={circleIcon}
          required={{
            required: requiredValidationDropdownMessage,
            onChange: changeCategoryStatus,
          }}
        />
      </Styled.FormContainer>
      <Styled.ButtonContainer>
        <PrimaryOutlineButton
          buttonWidth="112px"
          margin="0 24px 0 auto"
          type="button"
          icon={<BsX />}
          loading={isLoading}
          title="Cancel"
          onClick={closeCreateEditModal}
        />
        <PrimaryButton
          buttonWidth="108px"
          type="submit"
          loading={isLoading}
          title={modalAction.label ? 'Save' : 'Create'}
        />
      </Styled.ButtonContainer>
    </>
  );
};

ProductCategoryAddEditForm.propTypes = {
  setModalAction: PropTypes.func,
  modalAction: PropTypes.shape({
    label: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

ProductCategoryAddEditForm.defaultProps = {
  setModalAction: () => {},
  modalAction: {},
  loading: false,
};

export default ProductCategoryAddEditForm;
